import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Checkbox } from '../../../component';

import { RootState } from '../../../reducer';

import './heatmap.scss';
import Slider from '../../../component/form/slider/slider';
import { removeHeatmap } from './redux/heatmap.map';
import { changeOpacity, updateHeatmapType } from './redux/heatmap.reducer';
import { Map } from 'eemovel-map-library';
import {
  cleanHeatmap,
  createHeatmap,
  isHeatmapAvailable,
} from './controllers/heatmap.controller';

interface IDataLayersProps {
  isOpen: boolean;
}

const Heatmap = ({ isOpen }: IDataLayersProps): JSX.Element | null => {
  const dispatch = useDispatch();

  const { preference } = useSelector((state: RootState) => state.layoutState);

  const { menuAction } = useSelector(
    (state: RootState) => state.dashboardState.isActive
  );

  const { type, opacity } = useSelector((state: RootState) => state.heatmap);

  const nls = require(`./nls/${preference.language.id}.json`);
  const containerRef = useRef(null);

  const market = menuAction === '1' ? 'primaryMarket' : 'secondaryMarket';
  const handleChangeSwitchState = async (
    isSelected: boolean,
    selectedType: 'offers' | 'price'
  ) => {
    const isCurrentTypeActive = selectedType === type;
    if (!isSelected || isCurrentTypeActive) {
      dispatch(updateHeatmapType(''));
      await removeHeatmap();
      return;
    }
    dispatch(updateHeatmapType(selectedType));
    await createHeatmap(selectedType, market, opacity);
  };

  const options = [
    {
      id: 'offers',
      label: nls.quantityOffer,
      isSelected: type === 'offers',
    },
    // { id: 'price', label: nls.m2price, isSelected: type === 'price' },
  ] as const;

  useEffect(() => {
    if (!!Map.heatMap) {
      Map.heatMap.set('opacity', opacity);
    }
  }, [opacity]);

  if (!isHeatmapAvailable()) return null;

  return (
    <div className="data-layers-actions--full-container" ref={containerRef}>
      {isOpen && (
        <div className="data-layers--full-container">
          <p data-cy="DataLayersTitle" className="data-layer--title">
            {nls.layers}
          </p>

          <div className="heatmap-content-container">
            {options.map(({ id, label, isSelected }) => {
              return (
                <div key={crypto.randomUUID()}>
                  <Checkbox
                    cy={`heatmap${id}`}
                    action={(event) =>
                      handleChangeSwitchState(event as boolean, id)
                    }
                    name={id}
                    checked={isSelected}
                    label={label}
                    type="switch"
                  />
                  {isSelected && (
                    <div className="opacityRange">
                      <div className="opacityLabel">
                        <div>{nls.opacity}</div>
                        <div>{opacity * 100}%</div>
                      </div>
                      <Slider
                        min={0}
                        max={100}
                        step={10}
                        defaultValue={70}
                        value={opacity * 100}
                        onChange={(value) =>
                          dispatch(changeOpacity(Number(value) / 100))
                        }
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <Button
            cy="DataLayersClearBtn"
            className="data-layers-clear-button btn"
            onClick={cleanHeatmap}
          >
            Limpar Camadas
          </Button>
        </div>
      )}
    </div>
  );
};

export default Heatmap;
